export default import.meta.ROLLDOWN_FILE_URL_VRAku6fjghkApIISiBWPzg_344679ac52769b1da3fcebb7